// import amplitude from 'amplitude-js';
// import environment from 'kareo-environment-config';

// const apiKeys = {
//   devint: '4ce6727973838b97c6cea59c1ed98ee9',
//   test: '4ce6727973838b97c6cea59c1ed98ee9',
//   stage: '4ce6727973838b97c6cea59c1ed98ee9',
//   prod: '7dc03f42fd7761eb87f8dd319f7176e8', // disaster recovery
//   prodlas: '7dc03f42fd7761eb87f8dd319f7176e8', // real prod
// };

// amplitude.getInstance().init(apiKeys[environment]);

export default {
  identify: id => {
    // amplitude.getInstance().setUserId(id);
  },
  track: (event, properties) => {
    let promise = new Promise((resolve, reject) => {
      // amplitude
      //   .getInstance()
      //   .logEvent(event, properties, (responseCode, responseBody) => {
      //     let response = { code: responseCode, body: responseBody };
      //     if (responseCode >= 400) {
      //       reject(response);
      //     } else {
      //       // valid response so log event was successful
      //       resolve(response);
      //     }
      //   });

      setTimeout(() => {
        resolve();
      }, 0);
    });
    return promise;
  },
  setUserProperties: userProperties => {
    // amplitude.getInstance().setUserProperties(userProperties);
  },
};

// tracking name constants should follow Object-action Framework
// naming conventions for clean data - https://segment.com/academy/collecting-data/naming-conventions-for-clean-data/
export const EVENTS = {
  BUTTON_CLICKED: 'Button Clicked',
  LINK_CLICKED: 'Link Clicked',
  COMPONENT_LOADED: 'Component Loaded',
  FORM_SUBMITTED: 'Form Submitted',
  RADIO_CLICKED: 'Radio Clicked',
  UPDATE_SCHEDULING: 'PracticeScheduling Updated',
  PAYMENT_COLLECTED: 'Card Swiped with Swiper',
  BUTTON_TOGGLED: 'Button Toggled',
};
